/* unplugin-vue-components disabled */import script from "./EditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditModal.vue?vue&type=style&index=0&id=e11fa284&lang=less"

const __exports__ = script;

export default __exports__